import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { setLightboxOverlayVisibility, setLightboxSelectedImage, setScrollToApTarget } from 'modules/accommodation/slice';
import { AccommodationPageNavSections } from 'modules/accommodation/types';
import { hideOverlay } from 'modules/overlay/slice';
import { getRoomsResult } from 'modules/searchApi/selectors';
import { Button } from '@daedalus/atlas/Button';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
interface Props {
  trackOfferClicked: () => void;
  shouldCloseOverlayOnClick?: boolean;
}
const CTAWrapper = /*#__PURE__*/styled('div')({
  name: "CTAWrapper",
  class: "cpzvhcv",
  propsAsIs: false
});
export const PrimaryRoomOfferCTA = ({
  trackOfferClicked,
  shouldCloseOverlayOnClick
}: Props) => {
  const dispatch = useDispatch();
  const {
    isLoading
  } = useSelector(getRoomsResult);
  const onOfferClick = () => {
    if (shouldCloseOverlayOnClick) {
      dispatch(hideOverlay());
      dispatch(setScrollToApTarget({
        target: AccommodationPageNavSections.Rooms
      }));
      return;
    }
    if (isLoading) {
      return;
    }
    trackOfferClicked();
    dispatch(setLightboxOverlayVisibility(false));
    dispatch(setLightboxSelectedImage(undefined));
    dispatch(setScrollToApTarget({
      target: AccommodationPageNavSections.Rooms
    }));
  };
  return <CTAWrapper data-id="OfferCta">
      <Button variant="primary" size="xl" fullWidth onClick={onOfferClick}>
        <FormattedMessageWrapper id="viewRooms" defaultMessage="View rooms" />
      </Button>
    </CTAWrapper>;
};

require("./PrimaryRoomOfferCTA.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PrimaryRoomOfferCTA.tsx");